import React, { memo } from 'react';
import { Box, Typography, Divider, useTheme } from '@mui/material';

const CustomTooltip = ({ payload, label, sensorColors, threshold }) => {
  const theme = useTheme();

  if (!payload || payload.length === 0) {
    return null;
  }

  const date = new Date(label);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
  
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <Box className="sensor-tooltip" sx={{ maxWidth: 250 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {formattedDate} at {formattedTime}
      </Typography>
      
      <Divider sx={{ mb: 1 }} />
      
      {payload.map((entry, index) => {
        const value = entry.value;
        const isBelowThreshold = threshold && value < threshold;
        
        return (
          <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography 
              variant="body2"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                color: entry.color
              }}
            >
              <Box 
                component="span" 
                sx={{ 
                  display: 'inline-block', 
                  width: 12, 
                  height: 12, 
                  borderRadius: '50%', 
                  backgroundColor: entry.color,
                  mr: 1
                }} 
              />
              {entry.name}:
            </Typography>
            <Typography 
              variant="body2" 
              fontWeight="bold"
              color={isBelowThreshold ? theme.palette.error.main : 'inherit'}
            >
              {value.toFixed(1)}
              {isBelowThreshold && (
                <Typography 
                  component="span" 
                  variant="caption" 
                  color="error"
                  sx={{ ml: 0.5 }}
                >
                  (Below threshold)
                </Typography>
              )}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default memo(CustomTooltip);